import {
    AbstractControl,
    ValidatorFn
} from '@angular/forms';
import { IDatiqAutocomplete } from '../models';

export const MIN_LENGTH_ERROR_KEY = 'autocompleteMinLength';

export function minLen(num: any, settings: IDatiqAutocomplete): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const valid: boolean = control.value?.[0]?.value.length >= num;

            return !valid
            ? {
                  [MIN_LENGTH_ERROR_KEY]: {
                      num,
                  },
              }
            : null;
    };
}
